import React, { useState } from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import { bindActionCreators } from 'redux';

const SitesDropDown = props => {
  const [selection, setSelection] = useState([]);

  const handleChange = (e, { name, value }) => {
    props.formik.setFieldValue(name, value);
    if (props.multiple) {
      setSelection(value);
    }
  };

  const getField = () => (
    <Form.Field error={Boolean(props.error)}>
      <label>{props.label}</label>
      <Dropdown
        fluid
        search
        selection
        clearable
        selected={selection}
        multiple={props.multiple}
        key={props.id ? props.id + '-' + props.name : props.name}
        options={props.options}
        id={props.name}
        label={props.label}
        name={props.name}
        value={props.value}
        onChange={(e, d) => handleChange(e, d)}
      />
    </Form.Field>
  );

  return <> {props && props.options && getField()} </>;
};

const mapStateToProps = state => ({ options: selectors.admin.siteOptions(state) });

const mapDispatchToProps = dispatch => ({ getSites: bindActionCreators(actions.admin.getSites, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(SitesDropDown);
